import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userPrefsActions, userPrefsSelectors } from '../../store/modules/userprefs';

export const useFetchUserPrefs = () => {
  const dispatch = useDispatch();
  const userprefs = useSelector(userPrefsSelectors.selectUserPrefs);

  useEffect(() => {
    if (userprefs) return;

    dispatch(userPrefsActions.fetchUserPrefs());
  }, [userprefs]);
};

export default useFetchUserPrefs;
